module.exports = __webpack_public_path__ + "img/help34.0b598471.png";